/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { useEffect, useState } from 'react';
import { ChildHome } from './features/home/ChildHome';
import { AlphabetView } from './features/alphabet/AlphabetView';
import { SyllablesView } from './features/syllables/SyllablesView';
import { WordBuilderView } from './features/wordbuilder/WordBuilderView';
import { CameraReaderView } from './features/camera/CameraReaderView';
import { MyWordsView } from './features/mywords/MyWordsView';
import { GamesView } from './features/games/GamesView';
import { GardenView } from './features/garden/GardenView';
import { ParentDashboard } from './features/parent/ParentDashboard';
import { WritingView } from './features/writing/WritingView';
import { trackPageView } from './core/analytics/googleAnalytics';

type ActiveView =
  | 'home'
  | 'alphabet'
  | 'writing'
  | 'syllables'
  | 'wordbuilder'
  | 'camera'
  | 'mywords'
  | 'games'
  | 'garden'
  | 'parent';

export default function App() {
  const [currentView, setCurrentView] = useState<ActiveView>('home');

  useEffect(() => {
    trackPageView(currentView === 'home' ? '/' : `/${currentView}`);
  }, [currentView]);

  return (
    <div className="min-h-screen bg-[#FFFDF8] text-[#243047] font-sans">
      {currentView === 'home' && (
        <ChildHome onNavigate={view => setCurrentView(view)} />
      )}

      {currentView === 'alphabet' && (
        <AlphabetView onBack={() => setCurrentView('home')} />
      )}

      {currentView === 'writing' && (
        <WritingView onBack={() => setCurrentView('home')} />
      )}

      {currentView === 'syllables' && (
        <SyllablesView
          onBack={() => setCurrentView('home')}
          onGoToWordBuilder={() => setCurrentView('wordbuilder')}
        />
      )}

      {currentView === 'wordbuilder' && (
        <WordBuilderView onBack={() => setCurrentView('home')} />
      )}

      {currentView === 'camera' && (
        <CameraReaderView
          onBack={() => setCurrentView('home')}
          onGoToMyWords={() => setCurrentView('mywords')}
        />
      )}

      {currentView === 'mywords' && (
        <MyWordsView
          onBack={() => setCurrentView('home')}
          onOpenCamera={() => setCurrentView('camera')}
        />
      )}

      {currentView === 'games' && (
        <GamesView onBack={() => setCurrentView('home')} />
      )}

      {currentView === 'garden' && (
        <GardenView onBack={() => setCurrentView('home')} />
      )}

      {currentView === 'parent' && (
        <ParentDashboard onBack={() => setCurrentView('home')} />
      )}
    </div>
  );
}
